import { t } from "i18next";
import TranslationEdit from "../translation-edit/TranslationEdit";
import SimpleSelect from "../simple-select/SimpleSelect";
import { useEffect, useState } from "react";
import { api } from "../../../services/api/api";

/**
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function TechnicianTimeTypeForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.TimeType,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {

  const [languages, setLanguagesState] = useState<EasyTech.Language[]>([]);

  /**
  * useEffect: get languages list
  */
  useEffect(() => {
    api.get("users/languages")
      .then(ret  => {
        setLanguagesState(ret as EasyTech.Language[]);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  /***/

  return (
    <>
      <div className="field">
        <label htmlFor="label">{t("common:label")}</label>
        <input type="text"
                value={data?.label || ""}
                onChange={(e) => onChange("label", e.target.value)}
                className={`${(submitted && (!data || !data?.label)) && "error"}`}
                placeholder={t("common:label")}/>
      </div>

      <div className="field">
        <label htmlFor="visibility">{t("common:visibility")}</label>
        <SimpleSelect
          value={data?.visibility || "ALL"}
          options={[
            { value: "ALL", label: t("common:allUsers") },
            { value: "ADMIN", label: t("common:administratorsOnly") },
          ]}
          onChange={(value) => onChange("visibility", value || "ALL")}
        />
      </div>

      <div className="field">
        <label htmlFor="translation">{t("common:translation")}</label>
        <TranslationEdit key={data?.id} data={data?.translations} onChange={(v) => onChange("translations", v)} languages={languages}/>
      </div>
    </>
  );
}
